import { ExternalDimensioningResultTypename } from "shared/types/ExternalDimensioning"
import { ProductPosition } from "shared/types/ProductPosition"
import { ProductPositionTypename } from "shared/types/Project"

import { RestLink } from "apollo-link-rest"

export function patchProductPosition(
  productPosition: ProductPosition,
  outerType: string,
  patchDeeper: RestLink.FunctionalTypePatcher,
  context: RestLink.TypePatcherContext
): ProductPosition {
  return {
    ...productPosition,
    dimensioning: productPosition.dimensioning
      ? patchDeeper(
          {
            ...productPosition.dimensioning,
            __typename: ExternalDimensioningResultTypename
          },
          ProductPositionTypename,
          patchDeeper,
          context
        )
      : null,
    __typename: ProductPositionTypename
  }
}
